import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { checkPermissionKey } from '../utils/auth';

function PermissionGuard({ permissionKey, children }) {
    const location = useLocation();
    const hasPermission = checkPermissionKey(permissionKey);

    if (hasPermission) {
        return children;
    }

    return (
        <div className="min-h-[calc(100vh-64px)] bg-gray-50 p-6 flex items-center justify-center">
            <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl shadow-sm p-6">
                <h1 className="text-xl font-semibold text-gray-900 mb-2">アクセス権限がありません</h1>
                <p className="text-sm text-gray-600 mb-3">
                    このページを表示する権限がありません。必要に応じて管理者に権限付与を依頼してください。
                </p>
                <p className="text-xs text-gray-500 mb-5">
                    必要な権限キー: {permissionKey}
                </p>
                <div className="flex justify-end">
                    <Link
                        to="/"
                        state={{ from: location.pathname }}
                        className="inline-flex items-center px-4 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700 transition"
                    >
                        ホームへ戻る
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default PermissionGuard;
